import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useRef, useState } from "react";
import { getResultadosDomoAjustesAAQQ } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { getParametrosModelos } from "../../../services/services";

export default function PerfilGranulometrico() {
  // Variables que no cambiaran
  const STATIC_ARRAY = [300, 212, 150, 106, 75, 53, 45];

  const actual = [99.9, 99.4, 97.9, 94.4, 87.3, 73.5, 66.7];

  const diseno = [100, 100, 100, 100, 97, 91, 85];

  const minimo = [100, 100, 100, 99.4, 96.4, 88.4, 84.9];
  const maximo = [99.4, 98.5, 95.7, 89.2, 77.6, 42.7, 21.3];

  const [dchState, setDch] = useState(actual);
  const [dateGranu, setDateGranu] = useState(null);
  const timerIdRef = useRef(null);

  const [minimoGranu, setMinimoGranu] = useState(minimo);
  const [maximoGranu, setMaximoGranu] = useState(maximo);
  /**
   * Combina los arreglos con nuestro STATIC_ARRAY
   * @param {*} arr - array
   * @returns
   */
  function combineArrays(arr) {
    const resultado = STATIC_ARRAY.map(function (elem, i) {
      return [elem, arr[i]];
    });

    return resultado;
  }

  useEffect(() => {
    fData();

    if (timerIdRef.current) {
      clearTimeout(timerIdRef.current);
    }
    timerIdRef.current = setTimeout(() => {
      fData();
    }, 5000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fData() {
    const arrValues = [];
    const { data } = await getResultadosDomoAjustesAAQQ();
    const { Fecha } = data[0];

    setDateGranu(formatDate(Fecha));

    for (let i of Object.entries(data[0])) {
      if (i[0].includes("Acumulado")) {
        arrValues.push(i[1]);
      }
    }
    setDch(arrValues);
  }

  useEffect(() => {
    fetchGranulometrico();
  }, []);

  async function fetchGranulometrico() {
    const arrMinimo = [];
    const arrMaximo = [];

    const { data } = await getParametrosModelos();
    // Campos de parametros para grafico de granulometria
    const arrGranulometria = data.filter((element) => element.OrdenTipo === 3);

    arrGranulometria.forEach((element) => {
      arrMinimo.push(parseFloat(element.Valor));
      arrMaximo.push(parseFloat(element.Valor2));
    });

    setMinimoGranu(arrMinimo);
    setMaximoGranu(arrMaximo);
  }

  useEffect(() => {
    return () => {
      clearTimeout(timerIdRef.current);
    };
  }, []);

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            title={"Perfil Granulometríco"}
            subtitle={"Fecha: " + dateGranu}
            showTooltips={true}
            displayErrors={false}
          >
            <Chart.Line
              name="Alimentación Actual"
              data={combineArrays(dchState)}
              pointStart={1}
            ></Chart.Line>

            <Chart.Line
              name="Diseño"
              data={combineArrays(diseno)}
              pointStart={1}
            ></Chart.Line>

            <Chart.Line
              name="Minimo"
              data={combineArrays(minimoGranu)}
              pointStart={1}
            ></Chart.Line>

            <Chart.Line
              name="Maximo"
              data={combineArrays(maximoGranu)}
              pointStart={1}
            ></Chart.Line>

            <Chart.YAxis
              type="line"
              accessibility={{
                rangeDescription: "Range: 20 to 100",
                enabled: true,
              }}
              min={20}
              max={100}
              title={"Pasante Acumulado, %"}
            ></Chart.YAxis>

            <Chart.YAxis
              opposite={true}
              lineColor={"white"}
              lineWidth={2}
            ></Chart.YAxis>

            <Chart.XAxis
              title={"Tamaño particulas, µm"}
              type="logarithmic"
              accessibility={{
                rangeDescription: "Range: 1 to 1000",
                enabled: true,
              }}
              min={1}
              max={1000}
            ></Chart.XAxis>
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
